import React, { useState, useEffect } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  Tabs,
  Tab,
  TextField,
  Fade,
} from "@material-ui/core";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../context/firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { withRouter, useHistory } from "react-router-dom";
// styles
import useStyles from "./styles";

// logo
import ABlogo from "../../images/ABLogo.svg";

// context
import { useUserDispatch } from "../../context/UserContext";

//firebase
import "firebase/app";

import { UserAuth } from "../../context/AuthContext";
import { useAuthState } from "react-firebase-hooks/auth";

function Login(props) {
  var classes = useStyles();
  var userList = [];
  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [activeTabId, setActiveTabId] = useState(0);
  var [nameValue, setNameValue] = useState("");
  var [loginValue, setLoginValue] = useState("");
 
  var [passwordValue, setPasswordValue] = useState("");
  var [error, setError] = useState("");
  // const [user, loading] = useAuthState(auth);

  const navigate = useHistory();

  const { createUser, signIn } = UserAuth();
  const backToHome = () => {
    toast.info("😎 Jao ab Padhai Karo", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    navigate.push("/login");
  };
  const handleSignUp = async (e) => {
    e.preventDefault(); // prevent page reload
    setIsLoading(true);
    setError("");
    try {
      await createUser(userDispatch, loginValue, passwordValue);
      navigate.push("/login");
    } catch (e) {
      setError(e.message);
    }
    setIsLoading(false);
  };
  const check = async (loginValue) => {
    const data = await getDocs(collection(db, "admin"));
    data.docs.forEach((item) => {
      userList.push(
        item._document.data.value.mapValue.fields.email.stringValue
      );
    });
    console.log(userList.includes(loginValue));
    return userList.includes(loginValue);
  };
  const handleSignIn = async (e) => {
    e.preventDefault(); // prevent page reload
    setIsLoading(true);
    setError("");
    try {
      if ((await check(loginValue)) === true) {
        await signIn(loginValue, passwordValue);
        await navigate.push("/admin/dashboard");
      } else {
        alert("Something is wrong with your login or password :(");
      }
    } catch (e) {
      setError(e.message);
    }
    setIsLoading(false);
  };

  return (
    <Grid
      onContextMenu={(e) => e.preventDefault()}
      container
      className={classes.container}
    >
      <div className={classes.logotypeContainer}>
        <img src={ABlogo} alt="logo" className={classes.logotypeImage} />
        <Typography className={classes.logotypeText}>AB Physics</Typography>
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <Tabs
            value={activeTabId}
            onChange={(e, id) => setActiveTabId(id)}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Login" classes={{ root: classes.tab }} />
            <Tab label="New User" classes={{ root: classes.tab }} />
          </Tabs>
          {activeTabId === 0 && (
            <React.Fragment>
              <Typography variant="h1" className={classes.greeting}>
                Welcome, Admin
              </Typography>
              <Button size="large" className={classes.googleButton}>
                <img src={ABlogo} alt="logo" className={classes.ABIcon} />
                &nbsp;Sign in with Admin Permissions
              </Button>
              <div className={classes.formDividerContainer}>
                {/* <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>or</Typography>
                <div className={classes.formDivider} /> */}
              </div>
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  Something is wrong with your login or password :(
                </Typography>
              </Fade>
              <form onSubmit={handleSignIn}>
                <TextField
                  id="email"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={loginValue}
                  onChange={(e) => setLoginValue(e.target.value)}
                  margin="normal"
                  placeholder="Email Adress"
                  type="email"
                  fullWidth
                  autoComplete="username"
                />
                <TextField
                  id="password"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  margin="normal"
                  placeholder="Password"
                  type="password"
                  fullWidth
                  autoComplete="current-password"
                />
                <div className={classes.formButtons}>
                  {isLoading ? (
                    <CircularProgress
                      size={26}
                      className={classes.loginLoader}
                    />
                  ) : (
                    <Button
                      disabled={
                        loginValue.length === 0 || passwordValue.length === 0
                      }
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Login
                    </Button>
                  )}
                  <Button
                    color="secondary"
                    size="large"
                    className={classes.forgetButton}
                    onClick={backToHome}
                  >
                    Back to HOME
                  </Button>
                </div>
              </form>
            </React.Fragment>
          )}
          {activeTabId === 1 && (
            <React.Fragment>
              <Typography variant="h1" className={classes.greeting}>
                Oops{" "}
                <ErrorOutlineIcon style={{ fontSize: "2rem", color: "red" }} />
              </Typography>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <Typography variant="h5" className={classes.greeting}>
                Looks Like this part is still under development
                <br />
                Please try again later or contact Admin.
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Typography>
              <Typography variant="h4" className={classes.greeting}>
                <i>Thank You for your visit.</i>
              </Typography>
              {/* <Typography variant="h1" className={classes.greeting}>
                Welcome! Student
              </Typography>
              <Typography variant="h2" className={classes.subGreeting}>
                Create your account
              </Typography>
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  Something is wrong with your login or password :(
                </Typography>
              </Fade>
              <TextField
                id="name"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={nameValue}
                onChange={(e) => setNameValue(e.target.value)}
                margin="normal"
                placeholder="Full Name"
                type="text"
                fullWidth
              />
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Email Adress"
                type="email"
                fullWidth
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={passwordValue}
                onChange={(e) => setPasswordValue(e.target.value)}
                margin="normal"
                placeholder="Password"
                type="password"
                fullWidth
              />
              <div className={classes.creatingButtonContainer}>
                {isLoading ? (
                  <CircularProgress size={26} />
                ) : (
                  <Button
                    onClick={() =>
                      loginUser(
                        userDispatch,
                        loginValue,
                        passwordValue,
                        props.history,
                        setIsLoading,
                        setError
                      )
                    }
                    disabled={
                      loginValue.length === 0 ||
                      passwordValue.length === 0 ||
                      nameValue.length === 0
                    }
                    size="large"
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.createAccountButton}
                  >
                    Create your account
                  </Button>
                )}
              </div>
              <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>or</Typography>
                <div className={classes.formDivider} />
              </div>
              <Button
                size="large"
                className={classnames(
                  classes.googleButton,
                  classes.googleButtonCreating
                )}
              >
                <img src={google} alt="google" className={classes.googleIcon} />
                &nbsp;Sign in with Google
              </Button> */}
            </React.Fragment>
          )}
        </div>
        <Typography color="primary" className={classes.copyright}>
          © {new Date().getFullYear()} AB Physics, All rights reserved.
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
